import { ALL_FILTER_TYPES } from '@carrefour-gcs/shared';
import { z } from 'zod';

/**
 * One step of a tree filter path: the level it belongs to, and the key of the node.
 */
const TreePathSegmentZodSchema = z.object({ type: z.enum(ALL_FILTER_TYPES), key: z.string() });

export type TreePathSegmentType = z.infer<typeof TreePathSegmentZodSchema>;

/**
 * The highest fully-checked node of a tree filter, as its typed key path from the root.
 */
export const TreeSelectionZodSchema = z.object({ path: z.array(TreePathSegmentZodSchema).min(1) });

export type TreeSelectionType = z.infer<typeof TreeSelectionZodSchema>;
